import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <div className="logo-icon">⚡</div>
              <span style={{ fontSize: 18, fontWeight: 800 }} className="text-gradient">InfraVelox</span>
            </div>
            <p>Your premium DevOps mentorship hub. Master the tools and practices that power modern software infrastructure.</p>
            <div className="social-links" style={{ marginTop: 20 }}>
              <a href="#" title="Twitter">𝕏</a>
              <a href="#" title="LinkedIn">in</a>
              <a href="#" title="GitHub">⌥</a>
              <a href="#" title="YouTube">▶</a>
              <a href="#" title="WhatsApp">W</a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Platform</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><a href="/#tools">Tools</a></li>
              <li><a href="/#how-it-works">How It Works</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Tools</h4>
            <ul>
              <li><a href="#">Docker</a></li>
              <li><a href="#">Kubernetes</a></li>
              <li><a href="#">AWS</a></li>
              <li><a href="#">Terraform</a></li>
              <li><a href="#">Jenkins</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Support</h4>
            <ul>
              <li><Link to="/login">Login</Link></li>
              <li><Link to="/pricing">Get Started</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 InfraVelox. All rights reserved. Built with ❤️ for DevOps Engineers.</p>
          <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>
            Powered by <span className="text-gradient" style={{ fontWeight: 700 }}>Expert Mentors</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
